import { createRouter, createWebHistory } from "vue-router";
import { ROUTE_PATHS, ROUTE_NAME } from "./constants";
import { usePostHog } from "@/composables/usePosthog";
import Cookies from "js-cookie";
import { useWishesStore } from "@/stores/wishesStore";
import { useUserStore } from "@/stores/userStore";
const ESTATE_ROUTES = [
  ROUTE_PATHS.MY_ESTATE_PLAN,
  ROUTE_PATHS.WISHES,
  ROUTE_PATHS.ASSETS,
  ROUTE_PATHS.ESTATE_PLAN_WISHES,
  ROUTE_PATHS.ESTATE_PLAN_ASSET,
  ROUTE_PATHS.SPOUSAL_TRUST,
  ROUTE_PATHS.DEPENDENTS_TRUST,
  ROUTE_PATHS.PET_TRUST,
  ROUTE_PATHS.LIFE_SUPPORT,
  ROUTE_PATHS.BODY_HANDLING,
  ROUTE_PATHS.FUNERAL_PLANS,
  ROUTE_PATHS.ASSETS_BEQUEST,
  ROUTE_PATHS.CASH_BEQUEST,
  ROUTE_PATHS.DISINHERIT,
  ROUTE_PATHS.ADD_WISHES,
  ROUTE_PATHS.CHOOSE_ASSETS,
  ROUTE_PATHS.ADD_ASSETS_HOME,
  ROUTE_PATHS.WISHES_ONBOARDING,
  ROUTE_PATHS.ASSETS_ONBOARDING,
  ROUTE_PATHS.CIRCLE_ONBOARDING,
  ROUTE_PATHS.LEGACY,
  ROUTE_PATHS.DOCUMENTS,
];

const LICENSED_ROUTE_MAP = {
  digital_vault: [ROUTE_PATHS.DIGITAL_VAULT, ROUTE_PATHS.LEGACY],
  estate: [...ESTATE_ROUTES, ROUTE_PATHS.DIGITAL_VAULT],
  estate_trusts: [
    ...ESTATE_ROUTES,
    ROUTE_PATHS.REVOCABLE_TRUST,
    ROUTE_PATHS.DIGITAL_VAULT,
  ],
};

const routes = [
  {
    path: ROUTE_PATHS.LOGIN,
    name: ROUTE_NAME.LOGIN,
    component: () => import("@/views/Authentication/Login.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: ROUTE_PATHS.SIGNIN,
    name: ROUTE_NAME.SIGNIN,
    component: () => import("@/views/Authentication/Login.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: ROUTE_PATHS.USER_INCAPACITATION,
    name: ROUTE_NAME.USER_INCAPACITATION,
    component: () => import("@/views/Roles/userIncapacitationReport.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: ROUTE_PATHS.FORGOT_PASSWORD,
    name: ROUTE_NAME.FORGOT_PASSWORD,
    component: () => import("@/views/Authentication/ForgotPassword.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: ROUTE_PATHS.SIGNUP,
    name: ROUTE_NAME.SIGNUP,
    component: () => import("@/views/Authentication/SignUp.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: ROUTE_PATHS.SIGNUP_AND_SUBSCRIBE,
    name: ROUTE_NAME.SIGNUP_AND_SUBSCRIBE,
    component: () => import("@/views/Authentication/SignUpAndSubscribe.vue"),
  },
  {
    path: ROUTE_PATHS.USER_ON_BOARDING,
    name: ROUTE_NAME.USER_ON_BOARDING,
    component: () => import("@/views/Authentication/UserOnboarding.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: ROUTE_PATHS.TERMS,
    name: ROUTE_NAME.TERMS,
    component: () => import("@/views/Authentication/Terms.vue"),
    meta: {
      layout: "auth",
    },
  },
  {
    path: "/",
    meta: {
      layout: "main",
    },
    children: [
      {
        path: ROUTE_PATHS.NOTIFICATIONS,
        name: ROUTE_NAME.NOTIFICATIONS,
        component: () => import("@/views/Notifications/Notifications.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.PROFILE,
        name: ROUTE_NAME.PROFILE,
        component: () => import("@/views/Profile/Profile.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.DASHBOARD,
        name: ROUTE_NAME.DASHBOARD,
        component: () => import("@/views/Dashboard/Dashboard.vue"),
        meta: {
          requiresAuth: true,
          footer: true,
        },
      },
      {
        path: ROUTE_PATHS.TUTORIAL,
        name: ROUTE_NAME.TUTORIAL,
        component: () => import("@/views/Dashboard/Tutorial.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.MY_ESTATE_PLAN,
        name: ROUTE_NAME.MY_ESTATE_PLAN,
        component: () => import("@/views/EstatePlan/EstatePlanHomePage.vue"),
        meta: {
          requiresAuth: true,
          footer: true,
        },
      },
      {
        path: ROUTE_PATHS.DIGITAL_VAULT,
        name: ROUTE_NAME.DIGITAL_VAULT,
        component: () => import("@/views/DigitalVault/DigitalVault.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.LEGACY,
        name: ROUTE_NAME.LEGACY,
        component: () => import("@/views/Legacy/LegacyHomePage.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.DOCUMENTS,
        name: ROUTE_NAME.DOCUMENTS,
        component: () => import("@/views/Documents/DocumentsHomePage.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.CIRCLE,
        name: ROUTE_NAME.CIRCLE,
        component: () => import("@/views/EstatePlan/Circle/Circle.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ASSETS,
        name: ROUTE_NAME.ASSETS,
        component: () => import("@/views/EstatePlan/Assets/Assets.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.WISHES,
        name: ROUTE_NAME.WISHES,
        component: () => import("@/views/EstatePlan/Wishes/Wishes.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ACCOUNT_AGENT,
        name: ROUTE_NAME.ACCOUNT_AGENT,
        component: () =>
          import("@/views/EstatePlan/Circle/AccountAgentFlow/AccountAgent.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.EXECUTOR,
        name: ROUTE_NAME.EXECUTOR,
        component: () =>
          import("@/views/EstatePlan/Circle/Executor/Executor.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.TRUSTEE,
        name: ROUTE_NAME.TRUSTEE,
        component: () =>
          import("@/views/EstatePlan/Circle/Trustee/Trustee.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.GUARDIAN,
        name: ROUTE_NAME.GUARDIAN,
        component: () =>
          import("@/views/EstatePlan/Circle/Guardian/Guardian.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.PLAN_DOCUMENTS,
        name: ROUTE_NAME.PLAN_DOCUMENTS,
        component: () =>
          import("@/views/EstatePlan/PlanDocuments/PlanDocuments.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.CIRCLE_ONBOARDING,
        name: ROUTE_NAME.CIRCLE_ONBOARDING,
        component: () =>
          import("@/views/EstatePlan/Circle/CircleOnboarding.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ASSETS_ONBOARDING,
        name: ROUTE_NAME.ASSETS_ONBOARDING,
        component: () =>
          import("@/views/EstatePlan/Assets/AssetsOnboarding.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.WISHES_ONBOARDING,
        name: ROUTE_NAME.WISHES_ONBOARDING,
        component: () =>
          import("@/views/EstatePlan/Wishes/WishesOnboarding.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.REVOCABLE_TRUST,
        name: ROUTE_NAME.REVOCABLE_TRUST,
        component: () =>
          import("@/views/EstatePlan/Wishes/RevocableTrust/RevocableTrust.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.LIFE_SUPPORT,
        name: ROUTE_NAME.LIFE_SUPPORT,
        component: () =>
          import("@/views/EstatePlan/Wishes/LifeSupport/LifeSupport.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.SPOUSAL_TRUST,
        name: ROUTE_NAME.SPOUSAL_TRUST,
        component: () =>
          import("@/views/EstatePlan/Wishes/SpousalTrust/SpousalTrust.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.DEPENDENTS_TRUST,
        name: ROUTE_NAME.DEPENDENTS_TRUST,
        component: () =>
          import(
            "@/views/EstatePlan/Wishes/DependentsTrust/DependentsTrust.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.PET_TRUST,
        name: ROUTE_NAME.PET_TRUST,
        component: () =>
          import("@/views/EstatePlan/Wishes/PetTrust/PetTrust.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.FUNERAL_PLANS,
        name: ROUTE_NAME.FUNERAL_PLANS,
        component: () =>
          import("@/views/EstatePlan/Wishes/FuneralPlans/FuneralPlans.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.BODY_HANDLING,
        name: ROUTE_NAME.BODY_HANDLING,
        component: () =>
          import("@/views/EstatePlan/Wishes/BodyHandling/BodyHandling.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ESTATE_PLAN_CIRCLE,
        name: ROUTE_NAME.ESTATE_PLAN_CIRCLE,
        component: () =>
          import("@/views/EstatePlan/Circle/EstatePlanCircle.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ESTATE_PLAN_WISHES,
        name: ROUTE_NAME.ESTATE_PLAN_WISHES,
        component: () =>
          import("@/views/EstatePlan/Wishes/EstatePlanWishes.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.TRANSITION,
        name: ROUTE_NAME.TRANSITION,
        component: () => import("@/views/EstatePlan/Circle/Transitions.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.OPENING_SETTINGS,
        name: ROUTE_NAME.OPENING_SETTINGS,
        component: () =>
          import("@/views/EstatePlan/Circle/OpeningSettings.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.BENEFICIARIES,
        name: ROUTE_NAME.BENEFICIARIES,
        component: () =>
          import("@/views/EstatePlan/Circle/Beneficiaries/Beneficiaries.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.CHOOSE_BENEFICIARIES,
        name: ROUTE_NAME.CHOOSE_BENEFICIARIES,
        component: () =>
          import(
            "@/views/EstatePlan/Circle/Beneficiaries/ChooseBeneficiaries.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.HEALTH_POA,
        name: ROUTE_NAME.HEALTH_POA,
        component: () =>
          import("@/views/EstatePlan/Circle/HealthPOA/HealthPOA.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.HEALTH_SUPPORT,
        name: ROUTE_NAME.HEALTH_SUPPORT,
        component: () =>
          import("@/views/EstatePlan/Circle/HealthSupport/HealthSupport.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.FINANCIAL_POA,
        name: ROUTE_NAME.FINANCIAL_POA,
        component: () =>
          import("@/views/EstatePlan/Circle/FinancialPOA/FinancialPOA.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ESTATE_PLAN_ASSET,
        name: ROUTE_NAME.ESTATE_PLAN_ASSET,
        component: () =>
          import("@/views/EstatePlan/Assets/EstatePlanAssets.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.CHOOSE_ASSETS,
        name: ROUTE_NAME.CHOOSE_ASSETS,
        component: () => import("@/views/EstatePlan/Assets/ChooseAssets.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ADD_ASSETS_HOME,
        name: ROUTE_NAME.ADD_ASSETS_HOME,
        component: () => import("@/views/EstatePlan/Assets/AddAssetHome.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ASSETS_BEQUEST,
        name: ROUTE_NAME.ASSETS_BEQUEST,
        component: () => import("@/views/EstatePlan/Wishes/AssetBequest.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.DISINHERIT,
        name: ROUTE_NAME.DISINHERIT,
        component: () => import("@/views/EstatePlan/Wishes/Disinherit.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ADD_WISHES,
        name: ROUTE_NAME.ADD_WISHES,
        component: () => import("@/views/EstatePlan/Wishes/AddWishes.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.CASH_BEQUEST,
        name: ROUTE_NAME.CASH_BEQUEST,
        component: () => import("@/views/EstatePlan/Wishes/CashBequest.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.REMAINDER_DISTRIBUTION,
        name: ROUTE_NAME.REMAINDER_DISTRIBUTION,
        component: () =>
          import("@/views/EstatePlan/Wishes/RemainderDistribution.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.ROLES,
        name: ROUTE_NAME.ROLES,
        component: () => import("@/views/Roles/RolesMain.vue"),
        children: [
          {
            path: "",
            name: ROUTE_NAME.ROLES_MAIN,
            redirect: ROUTE_PATHS.ROLES_AGENT,
          },
          {
            path: ROUTE_PATHS.AGENT,
            name: ROUTE_NAME.AGENT_PLAN_LIST,
            component: () =>
              import("@/views/Roles/AgentResponsibilitiesTab.vue"),
          },
          {
            path: "agent/plan/:id/:userId",
            name: ROUTE_NAME.AGENT_PLAN_DETAILS,
            component: () => import("@/views/Roles/PlanDetails.vue"),
            props: true,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: ROUTE_PATHS.OTHER,
            name: ROUTE_NAME.OTHER_ROLES,
            component: () => import("@/views/Roles/OtherRolesTab.vue"),
          },
          {
            path: "other/plan/:id",
            name: ROUTE_NAME.OTHER_PLAN_DETAILS,
            component: () => import("@/views/Roles/PlanDetails.vue"),
            props: true,
          },
          {
            path: ROUTE_PATHS.REQUESTS,
            name: ROUTE_NAME.ROLES_REQUESTS,
            component: () => import("@/views/Roles/RequestsTab.vue"),
            children: [
              {
                path: "request/:id",
                name: ROUTE_NAME.ROLES_REQUEST_DETAILS,
                component: () => import("@/views/Roles/RequestsTab.vue"),
                props: true,
              },
            ],
          },
        ],
        meta: {
          requiresAuth: true,
          footer: false,
        },
      },
      {
        path: ROUTE_PATHS.SECURITY,
        name: ROUTE_NAME.SECURITY,
        component: () => import("@/views/Security/SecurityMain.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTE_PATHS.AGENT_DIGITAL_VAULT,
        name: ROUTE_NAME.AGENT_DIGITAL_VAULT,
        component: () => import("@/views/DigitalVault/AgentDigitalVault.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: ROUTE_PATHS.NOT_FOUND,
    name: ROUTE_NAME.NOT_FOUND,
    component: () => import("@/views/NotFound.vue"),
  },
  {
    path: ROUTE_PATHS.FORBIDDEN_PAGE,
    name: ROUTE_NAME.FORBIDDEN_PAGE,
    component: () => import("@/views/Profile/403Page.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const PUBLIC_ROUTES = [
  ROUTE_PATHS.LOGIN,
  ROUTE_PATHS.SIGNIN,
  ROUTE_PATHS.SIGNUP,
  ROUTE_PATHS.SIGNUP_AND_SUBSCRIBE,
  ROUTE_PATHS.FORGOT_PASSWORD,
  ROUTE_PATHS.USER_ON_BOARDING,
  ROUTE_PATHS.TUTORIAL,
  ROUTE_PATHS.ROLES,
  ROUTE_PATHS.ROLES_AGENT,
  ROUTE_PATHS.ROLES_AGENT_PLAN,
  ROUTE_PATHS.ROLES_OTHER,
  ROUTE_PATHS.ROLES_REQUESTS,
  ROUTE_PATHS.SECURITY,
  ROUTE_PATHS.FORBIDDEN_PAGE,
  ROUTE_PATHS.AGENT_DIGITAL_VAULT,
  ROUTE_PATHS.NOTIFICATIONS,
];

const SUBSCRIPTION_EXEMPT_ROUTES = [
  ROUTE_PATHS.PROFILE,
  ROUTE_PATHS.TUTORIAL,
  ...PUBLIC_ROUTES,
];

// Helper function to check if user is authenticated
function checkAuthentication() {
  const refreshToken = Cookies.get("refreshToken");
  const expireTime = Cookies.get("expireTime");
  return !!refreshToken && !!expireTime;
}

// Helper function to get login response from cookie
function getLoginResponse() {
  const cookieData = Cookies.get("loginResponse");
  if (!cookieData) return {};

  try {
    return typeof cookieData === "string" ? JSON.parse(cookieData) : cookieData;
  } catch (e) {
    console.error("Error parsing loginResponse cookie:", e);
    return {};
  }
}

// Helper function to check if route is exempt from subscription checks
function isRouteExempt(path) {
  return (
    SUBSCRIPTION_EXEMPT_ROUTES.includes(path) ||
    path.startsWith("/roles/agent/plan/") ||
    path.startsWith("/agent-digital-vault/") ||
    path.startsWith("/roles/requests/request/")
  );
}

// Helper function to handle subscription validation
function handleSubscriptionValidation(to, activeLicenses, next) {
  const isExempt = isRouteExempt(to.path);

  if (!isExempt && activeLicenses.length === 0) {
    if (to.path === ROUTE_PATHS.DASHBOARD) {
      next({ path: ROUTE_PATHS.TUTORIAL });
      return true;
    }

    if (to.path !== ROUTE_PATHS.TUTORIAL && to.path !== ROUTE_PATHS.PROFILE) {
      next({ path: ROUTE_PATHS.PROFILE });
      return true;
    }
  }

  return false;
}

// Helper function to check license-based route access
function checkLicenseAccess(to, activeLicenses, next) {
  const hasRouteAccess = activeLicenses.some((license) => {
    const allowedRoutes = LICENSED_ROUTE_MAP[license] || [];
    return allowedRoutes.includes(to.path);
  });

  const isLicensedRoute = Object.values(LICENSED_ROUTE_MAP)
    .flat()
    .includes(to.path);

  if (!hasRouteAccess && isLicensedRoute) {
    next({ path: ROUTE_PATHS.FORBIDDEN_PAGE });
    return true;
  }

  return false;
}

// Helper function to handle authenticated route logic
function handleAuthenticatedRoute(to, userStore, next) {
  const loginResponse = getLoginResponse();
  const activeLicenses = loginResponse.licenses || [];

  // Check subscription and license access
  return (
    handleSubscriptionValidation(to, activeLicenses, next) ||
    checkLicenseAccess(to, activeLicenses, next)
  );
}

// Updated router beforeEach guard with reduced complexity
router.beforeEach(async (to, from, next) => {
  const wishesStore = useWishesStore();
  const userStore = useUserStore();
  const isAuthenticated = checkAuthentication();

  // Handle unauthenticated access to protected routes
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: ROUTE_NAME.LOGIN });
    return;
  }

  // Handle authenticated users accessing login page
  if (to.path === ROUTE_PATHS.LOGIN && isAuthenticated) {
    if (userStore.isIncapacited === "incapacitated") {
      next();
      return;
    }
    next({ name: ROUTE_NAME.DASHBOARD });
    return;
  }

  // Handle authenticated route logic
  if (to.meta.requiresAuth && isAuthenticated) {
    if (handleAuthenticatedRoute(to, userStore, next)) {
      return;
    }
  }

  // Handle unsaved changes
  if (wishesStore.hasUnsavedChanges) {
    wishesStore.pendingNavigation = () => {
      wishesStore.clearUnsavedChanges();
      router.replace(to);
    };
    wishesStore.openModal();
    next(false);
    return;
  }

  next();
});

const { postHog } = usePostHog();

// Handle stale chunk errors gracefully (detects new deployments)
router.onError((error) => {
  const chunkFailed =
    /Failed to fetch dynamically imported module/.test(error.message) ||
    /Loading chunk [\w-]+ failed/.test(error.message);

  if (chunkFailed) {
    console.warn("[App] Outdated build detected. Prompting user to refresh.");

    // Dispatch a global event instead of refreshing automatically
    window.dispatchEvent(new CustomEvent("app-version-outdated"));
  }
});

export default router;
